/*
 * des 特色资源push稿
 * author lileilei
 * date 2018-01-17
 */
'use strict';
angular.module('resCenPushModule', ['resCenPushRouterModule', 'resCenPushLeftModule', 'pushQuickPreview']).controller('resCenPushCtrl', [
    '$scope',
    '$q',
    '$element',
    '$state',
    '$filter',
    '$stateParams',
    'trsspliceString',
    'modalDialog',
    'trsHttpService',
    'trsPrintService',
    'storageListenerService',
    'resCtrModalService',
    'resourceCenterService',
    function(
        $scope,
        $q,
        $element,
        $state,
        $filter,
        $stateParams,
        trsspliceString,
        modalDialog,
        trsHttpService,
        trsPrintService,
        storageListenerService,
        resCtrModalService,
        resourceCenterService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            // decode($stateParams.nodename); //将路由上面的参数解码为汉字参数
            $scope.page = {
                CURRPAGE: 1,
                ITEMCOUNT: '',
                PAGECOUNT: '',
                PAGESIZE: 20,
            };
            $scope.jumpToPageNum = 1;
            $scope.status = {
                batchOperateBtn: {
                    hoverStatus: '',
                },
            };
            $scope.params = {
                typeid: 'zyzx',
                serviceid: 'appPush',
                modelid: 'findFromNavigation',
                nodeId: 'push',
                pageSize: $scope.page.PAGESIZE,
                pageNum: '1',
                keyword: {
                    // keywords: "",
                    // title: "",
                    // content: "",
                    hid: $stateParams.hid,
                    // name: $stateParams.nodename == '未选择' ? '' : $stateParams.nodename
                },
            };
            $scope.data = {
                items: [],
                selectedArray: [],
                operFlags: [],
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            listenStorage();
            initDropDown().then(function() {
                if (angular.isDefined($scope.$root.backFilterData)) {
                    // 判断是否有传递的数据
                    /* $timeout(function() {*/
                    $scope.page = $scope.$root.backFilterData.page;
                    $scope.params.page = $scope.page.CURRPAGE;
                    $scope.params.pageSize = $scope.page.PAGESIZE;
                    $scope.params.keyword = $scope.$root.backFilterData.keyword;
                    $scope.params.keyword.title = $scope.$root.backFilterData.keyword.title;
                    $scope.params.keyword.content = $scope.$root.backFilterData.keyword.content;
                    if (!!$scope.params.keyword.keywords) {
                        // 当前检索词
                        if ($scope.$root.backFilterData.filterSelected.value == 'all') {
                            $scope.data.pushSelected = angular.copy($scope.data.pushAll[0]);
                        } else if ($scope.$root.backFilterData.filterSelected.value == 'title') {
                            $scope.data.pushSelected = angular.copy($scope.data.pushAll[1]);
                        } else {
                            $scope.data.pushSelected = angular.copy($scope.data.pushAll[2]);
                        }
                    }
                    requestData();

                    /* }, 0);*/
                } else {
                    requestData();
                }
            });
            $scope.$on('$destroy', function() {
                delete $scope.$root.backFilterData;
            });
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenResource(function() {
                requestData();
                storageListenerService.removeListener('resource');
            }, $scope);
        }

        /**
         * [initDropDown description] 初始化搜索下拉框
         * @return {[type]} [description]
         */
        function initDropDown() {
            var deferred = $q.defer();
            $scope.data.pushAll = [
                {
                    name: '全部',
                    value: 'all',
                },
                {
                    name: '标题',
                    value: 'title',
                },
                {
                    name: '正文',
                    value: 'content',
                },
            ];
            $scope.data.pushSelected = angular.copy($scope.data.pushAll[0]);
            deferred.resolve();
            return deferred.promise;
        }

        /**
         * [getFilterTimeVal description]检索下拉框回调
         * @return {[type]} [description]
         */
        $scope.getFilterVal = function() {
            $scope.$root.backFilterData.filterSelected = $scope.data.pushSelected;
            if ($scope.data.pushSelected.value == 'all') {
                $scope.$root.backFilterData.keyword.content = $scope.$root.backFilterData.keyword.title = $scope.$root.backFilterData.keyword.keywords =
                    $scope.params.keyword.keywords;
            } else if ($scope.data.pushSelected.value == 'title') {
                $scope.$root.backFilterData.keyword.title = $scope.$root.backFilterData.keyword.keywords = $scope.params.keyword.keywords;
                $scope.$root.backFilterData.keyword.content = '';
            } else {
                $scope.$root.backFilterData.keyword.content = $scope.$root.backFilterData.keyword.keywords = $scope.params.keyword.keywords;
                $scope.$root.backFilterData.keyword.title = '';
            }
        };

        /**
         * [requestData description] 请求数据
         * @return {[type]} [description]
         */
        function requestData() {
            var params = angular.copy($scope.params);
            params.keyword = JSON.stringify(params.keyword);
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.data.items = data.content;
                $scope.page.ITEMCOUNT = data.summary_info.ITEMCOUNT;
                $scope.page.PAGECOUNT = data.summary_info.PAGECOUNT;
                $scope.data.indexName = data.summary_info.indexName;
                storageListenerService.previewPageTurningStorage($scope.data.items, 'GUID', 'resourceDetail');
                initOperFlag();
            });
        }

        /**
         * [initOperFlag description] 初始化取签见撤重
         */
        function initOperFlag() {
            var docIds = trsspliceString.spliceString($scope.data.items, 'GUID', ',');
            if (docIds) {
                var params = {
                    methodname: 'queryFlag',
                    serviceid: 'mlf_bigdataexchange',
                    guids: docIds,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    $scope.data.operFlags = [];
                    var temp = data;
                    for (var i in temp) {
                        if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                            $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                        }
                    }
                });
            }
        }

        /**
         * [filterName description] 处理客户端名字
         * @return {[type]}           [description]
         */
        $scope.filterName = function(name) {
            if (name.indexOf('客户端') > -1) {
                return name.replace('客户端', '');
            } else {
                return name;
            }
        };

        /**
         * [showOperFlag description] 显示取签见撤重标志
         * @param  {[type]} guid      [description]
         * @param  {[type]} flagIndex [description]
         * @return {[type]}           [description]
         */
        $scope.showOperFlag = function(guid, flagIndex) {
            var temp = queryItemBYGUID(guid);
            if (!!temp) {
                return queryItemBYGUID(guid).OPERFLAG.substr(flagIndex, 1) == '1';
            } else {
                return false;
            }
        };

        /**
         * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
         * @param  {[type]} guid [description]
         * @return {[type]}      [description]
         */
        function queryItemBYGUID(guid) {
            for (var i in $scope.data.operFlags) {
                if (guid == $scope.data.operFlags[i].GUID) {
                    return $scope.data.operFlags[i];
                }
            }
        }

        /**
         * @param  {[type]} ChnlDocId  [description] 取签见撤重 点击弹出
         * @param  {[type]} showRepeat [description]
         * @return {[type]}            [description]
         */
        $scope.viewBigDataInfo = function(ChnlDocId, showRepeat, showClick) {
            var operFlags = queryItemBYGUID(ChnlDocId).OPERFLAG;
            var infoModal = resCtrModalService.bigDataInfoModal(ChnlDocId, showRepeat, showClick, operFlags);
        };

        /**
         * [openTakeDraftModal description] 取稿
         * @return {[type]} [description]
         */
        $scope.openTakeDraftModal = function() {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'fetch',
                guid: trsspliceString.spliceString($scope.data.selectedArray, 'GUID', ','),
                indexName: $scope.data.indexName,
                channelName: 'appPush',
            };
            var isOnlyOne = !($scope.data.selectedArray.length > 1);
            var modalInstance = resCtrModalService.fullTakeDraft(params, isOnlyOne, $scope.data.selectedArray);
            modalInstance.result.then(
                function(data) {
                    takeDraftDownloadImgs(data).then(function() {
                        initOperFlag();
                        $scope.data.selectedArray = [];
                    });
                },
                function() {

                    /* initOperFlag();
                    $scope.data.selectedArray = [];*/
                }
            );
        };

        /**
         * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
         * @param  {[type]} data [description]
         * @return {[type]}      [description]
         */
        function takeDraftDownloadImgs(data) {
            var deferred = $q.defer();
            var needDownloadImg = false;
            for (var i = 0; i < data.REPORTS.length; i++) {
                if (data.REPORTS[i].PICERROR == 1) {
                    needDownloadImg = true;
                    break;
                }
            }
            if (needDownloadImg) {
                resCtrModalService.takeDraftDownloadImgs(data, function(res) {
                    deferred.resolve();
                });
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        }
        // 个人素材(稿件批量添加到个人素材)
        $scope.CreationAxis = function() {
            var params = {
                typeid: 'zyzx',
                serviceid: 'mlf_bigdataexchange',
                methodname: 'batchPersonalMaterial',
                channelName: 'appPush', // 栏目名称全拼结构
                PersonalMaterialId: 0, // 所属文件夹ID，默认根节点（0）
                indexName: $scope.data.indexName,
                guid: trsspliceString.spliceString($scope.data.selectedArray, 'GUID', ','),
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('添加成功', '', 'success', false, function() {
                    $scope.data.selectedArray = [];
                });
            });
        };

        /**
         * [openReserveDraftModal description] 预留稿件
         * @return {[type]} [description]
         */
        $scope.openReserveDraftModal = function() {
            var selectedArray = $scope.data.selectedArray;
            if (selectedArray.length === 0) {
                modalDialog.alertType('请先选择稿件！', '', 'warning', false);
                return;
            }
            var resCtrModalServiceModal = resCtrModalService.reserveDraft(selectedArray);
            resCtrModalServiceModal.result.then(function(result) {
                delete result.items;
                var params = {
                    serviceid: 'mlf_bigdataexchange',
                    methodname: 'delay',
                    guid: trsspliceString.spliceString($scope.data.selectedArray, 'GUID', ','),
                    indexName: $scope.data.indexName,
                    channelName: 'appPush',
                };
                params = angular.extend(params, result);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                    function(data) {
                        modalDialog.alertType('预留成功!', '', 'success', false, function() {
                            initOperFlag();
                            $scope.data.selectedArray = [];
                        });
                    },
                    function() {
                        initOperFlag();
                        $scope.data.selectedArray = [];
                    }
                );
            });
        };

        /**
         * [collect description] 收藏稿件
         * @return {[type]} [description]
         */
        $scope.collect = function() {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'collect',
                guid: trsspliceString.spliceString($scope.data.selectedArray, 'GUID', ','),
                indexName: $scope.data.indexName,
                channelName: 'appPush',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('收藏成功!', '', 'success', false, function() {
                    $scope.data.selectedArray = [];
                });
            });
        };

        /**
         * [printBtn description] 打印稿件
         * @return {[type]} [description]
         */
        $scope.printBtn = function() {
            if ($scope.data.selectedArray.length === 0) {
                modalDialog.alertType('请先选择稿件！', '', 'warning', false);
                return;
            }
            var params = {
                typeid: 'zyzx',
                serviceid: 'appPush',
                modelid: 'detailData',
                indexName: $scope.data.indexName,
                isDetail: false,
                typeName: 'push',
                guid: trsspliceString.spliceString($scope.data.selectedArray, 'GUID', ','),
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                for (var i = 0; i < data.content.length; i++) {
                    data.content[i].updatetime = data.content[i].DOCPUBTIME;
                    data.content[i].TXS = Number(data.content[i].TXS);
                }
                trsPrintService.trsPrintRobot(data);
                // $scope.data.selectedArray = [];
            });
        };

        /**
         * [export description] 导出稿件
         * @return {[type]} [description]
         */
        $scope.export = function() {
            if ($scope.data.selectedArray.length === 0) {
                modalDialog.alertType('请先选择稿件！', '', 'warning', false);
                return;
            }
            var params = {
                serviceid: 'mlf_exportword',
                methodname: 'exportBigDataDocs',
                GUIDS: trsspliceString.spliceString($scope.data.selectedArray, 'GUID', ','),
                channelName: 'appPush',
                CHANNELNAMES: 'appPush',
                indexName: $scope.data.indexName,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                window.open('/wcm/app/file/read_file.jsp?FileName=' + data);
                $scope.data.selectedArray = [];
            });
        };

        /**
         * [search description] 检索
         * @param  {[type]} ev [description]
         * @return {[type]}    [description]
         */
        $scope.search = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                if ($scope.data.pushSelected.value == 'title') {
                    $scope.params.keyword.title = $scope.params.keyword.keywords;
                    $scope.params.keyword.content = '';
                } else if ($scope.data.pushSelected.value == 'content') {
                    $scope.params.keyword.title = '';
                    $scope.params.keyword.content = $scope.params.keyword.keywords;
                } else {
                    $scope.params.keyword.title = $scope.params.keyword.keywords;
                    $scope.params.keyword.content = $scope.params.keyword.keywords;
                }
                $scope.page.CURRPAGE = $scope.jumpToPageNum = 1;
                $scope.params.page = 1;
                requestData();
            }
        };

        /**
         * [selectAll description] 全选
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [selectDoc description] 多选
         * @return {[type]} [description]
         */
        $scope.selectDoc = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };

        /**
         * [pageChanged description] 分页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.params.pageNum = $scope.page.CURRPAGE;
            $scope.jumpToPageNum = $scope.page.CURRPAGE;
            $scope.data.selectedArray = [];
            requestData();
            resourceCenterService.scrollTop($element);
        };

        /**
         * [quickPreview description] 快速预览模式
         * @return {[type]} [description]
         */
        $scope.quickPreview = function() {
            $scope.params.keyword.title =
                $scope.data.pushSelected.value == 'all'
                    ? $scope.params.keyword.keywords
                    : $scope.data.pushSelected.value == 'title'
                        ? $scope.params.keyword.keywords
                        : '';
            $scope.params.keyword.content =
                $scope.data.pushSelected.value == 'all'
                    ? $scope.params.keyword.keywords
                    : $scope.data.pushSelected.value == 'content'
                        ? $scope.params.keyword.keywords
                        : '';
            $scope.$root.filterData = {
                page: $scope.page, // 分页
                keyword: $scope.params.keyword, // 检索词
                filterSelected: $scope.data.pushSelected,
            };
            $state.go('front.networksource.featuredresource.push.quickpreview', $stateParams);
        };

        /**
         * [openPageForSearch description] 打开高级检索新页面
         * @return {[date]} [description]
         */
        $scope.openPageForSearch = function() {
            var url = $state.href('resadvancedsearch');
            window.open(url, '_blank');
        };
    },
]);
